var icons = {
  'play': '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 126 126"><circle class="cls-1" cx="63" cy="63" r="63"/><path class="cls-2" d="M100.48,61.28l-57-32.58a2,2,0,0,0-3,1.72V95.58a2,2,0,0,0,3,1.72l57-32.58A2,2,0,0,0,100.48,61.28Z"/></svg>',
  'pause': '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 126 126"><circle class="cls-1" cx="63" cy="63" r="63"/><rect class="cls-2" x="40.5" y="31.5" width="18" height="63" rx="2" ry="2"/><rect class="cls-2" x="67.5" y="31.5" width="18" height="63" rx="2" ry="2"/></svg>',
  'audio-on': '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 126 126"><circle class="cls-1" cx="63" cy="63" r="63"/><path class="cls-2" d="M64.53,28.7,36,45H24.5a2,2,0,0,0-2,2V79a2,2,0,0,0,2,2H36L64.53,97.3a2,2,0,0,0,3-1.72V30.42A2,2,0,0,0,64.53,28.7Z"/><path class="cls-2" d="M94.5,63A27,27,0,0,0,79.57,38.85l-2,4a22.5,22.5,0,0,1,0,40.25l2,4A27,27,0,0,0,94.5,63Z"/><path class="cls-2" d="M83.6,30.8l-2,4a31.5,31.5,0,0,1,0,56.35l2,4a36,36,0,0,0,0-64.4Z"/></svg>',
  'audio-off': '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 126 126"><defs><style>.cls-3{fill:none;stroke:#231f20;stroke-linecap:round;stroke-miterlimit:10;stroke-width:6px;}</style></defs><circle class="cls-1" cx="63" cy="63" r="63"/><path class="cls-2" d="M64.53,28.7,36,45H24.5a2,2,0,0,0-2,2V79a2,2,0,0,0,2,2H36L64.53,97.3a2,2,0,0,0,3-1.72V30.42A2,2,0,0,0,64.53,28.7Z"/><line class="cls-3" x1="81" y1="70.57" x2="99" y2="52.57"/><line class="cls-3" x1="99" y1="70.57" x2="81" y2="52.57"/></svg>',
  'fullscreen': '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 126 126"><circle class="cls-1" cx="63" cy="63" r="63"/><rect class="cls-2" x="31.5" y="31.5" width="27" height="9" rx="2" ry="2"/><rect class="cls-2" x="67.5" y="31.5" width="27" height="9" rx="2" ry="2"/><rect class="cls-2" x="22.5" y="40.5" width="27" height="9" rx="2" ry="2" transform="translate(-9 81) rotate(-90)"/><rect class="cls-2" x="22.5" y="76.5" width="27" height="9" rx="2" ry="2" transform="translate(-45 117) rotate(-90)"/><rect class="cls-2" x="76.5" y="40.5" width="27" height="9" rx="2" ry="2" transform="translate(45 135) rotate(-90)"/><rect class="cls-2" x="76.5" y="76.5" width="27" height="9" rx="2" ry="2" transform="translate(9 171) rotate(-90)"/><rect class="cls-2" x="67.5" y="85.5" width="27" height="9" rx="2" ry="2"/><rect class="cls-2" x="31.5" y="85.5" width="27" height="9" rx="2" ry="2"/></svg>',
  'restore': '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 126 126"><circle class="cls-1" cx="63" cy="63" r="63"/><rect class="cls-2" x="31.5" y="49.5" width="27" height="9" rx="2" ry="2"/><rect class="cls-2" x="67.5" y="49.5" width="27" height="9" rx="2" ry="2"/><rect class="cls-2" x="40.5" y="40.5" width="27" height="9" rx="2" ry="2" transform="translate(9 99) rotate(-90)"/><rect class="cls-2" x="40.5" y="76.5" width="27" height="9" rx="2" ry="2" transform="translate(-27 135) rotate(-90)"/><rect class="cls-2" x="58.5" y="40.5" width="27" height="9" rx="2" ry="2" transform="translate(27 117) rotate(-90)"/><rect class="cls-2" x="58.5" y="76.5" width="27" height="9" rx="2" ry="2" transform="translate(-9 153) rotate(-90)"/><rect class="cls-2" x="67.5" y="67.5" width="27" height="9" rx="2" ry="2"/><rect class="cls-2" x="31.5" y="67.5" width="27" height="9" rx="2" ry="2"/></svg>'
}

Number.prototype.toHHMMSS = function (currentTimeLength) {
  var sec_num = Math.floor(this); // don't forget the second param
  var minutes = Math.floor(sec_num / 60);
  var seconds = sec_num - (minutes * 60);

  if (minutes < 10) {minutes = "0"+minutes;}
  if (seconds < 10) {seconds = "0"+seconds;}

  var timeStr = minutes+':'+seconds;
  if (currentTimeLength) {
    timeStr = Array(currentTimeLength - timeStr.length + 1).join('0') + timeStr;
  }
  return timeStr;
};

class PlayerUtils {
    // ritorna SHAKA/FLASH/NATIVE
    // in base alle capacità del browser/SO
    static GetPlayerMode() {
      if (shaka.Player.isBrowserSupported()) {
        // https://stackoverflow.com/questions/7451635/how-to-detect-supported-video-formats-for-the-html5-video-tag?utm_medium=organic&utm_source=google_rich_qa&utm_campaign=google_rich_qa
        var testEl = document.createElement( "video" ), h264;
        if ( testEl.canPlayType ) {
          h264 = "" !== ( testEl.canPlayType( 'video/mp4; codecs="avc1.42E01E"' )
            || testEl.canPlayType( 'video/mp4; codecs="avc1.42E01E, mp4a.40.2"' ) );
        }

        if (h264) {
          return "SHAKA";
        }
        else {
          return "FLASH";
        }
      }
      else {
        return "NATIVE";
      }
    }

    static onErrorEvent(event) {
        // Extract the shaka.util.Error object from the event.
        onError(event.detail);
    }
    static onError(error) {
        // Log the error.
        console.error('Error code', error.code, 'object', error);
    }

}

class PlayerDesc {

    constructor(element) {
      this.element = element;
      this.$element = $(this.element);
      this.playerId = element.id;
      this.mode = (this.$element.data('mode') || 'vod').toLowerCase();
      this.mid = this.$element.data('mid');
      this.cid = this.$element.data('cid');
      this.type = (this.$element.data('type') || 'V').toUpperCase();
      this.autoplay = this.$element.data('autoplay') || false;
      this.isembed = this.$element.data('embed') || false;
      this.isazure = this.$element.data('azure') || false;
      this.baseurl = this.$element.data('baseurl'); // è obbligatorio
      this.resource = this.$element.data('resource'); // è obbligatorio
      this.poster = this.$element.data('poster') || null; // è obbligatorio
      this.tracksrc = this.$element.data('tracksrc') || null;
      this.istrack = Boolean(this.tracksrc);
      this.startat = this.$element.data('startat') || null;
      this.endat = this.$element.data('endat') || 1000000;
      this.startchapter = this.$element.data('startchapter') || null;
      this.chapters = this.$element.data('chapters') || null;
      this.navigator = this.$element.data('navigator') || null;
      this.ishistory = this.$element.data('history') || true;
      this.controls = (this.$element.data('controls') || 'custom').toLowerCase();
      this.iscustomcontrols = this.controls == 'custom';
      this.title = this.$element.data('title') || null;
      this.isinfooverlay = this.iscustomcontrols && (this.$element.data('infooverlay') || false);
    }

    // questa funzione costruisce l'url del manifesto in base alle caratterisrtiche del media
    // type può essere DASH/HSL/RTMP
    getManifestURL(streamtype) {
      const mode = 'SMIL';

      streamtype = streamtype || 'DASH';
      streamtype = streamtype.toUpperCase();
      var url = this.baseurl;

      // if (streamtype == 'DASH' && this.type == "A") {
      //   streamtype = 'HSL';
      //   //url = url.replace('/vod/', '/mp3/');
      // }

      if (streamtype == 'RTMP') {
        url = url.replace('http://', 'rtmp://');
      }
      switch (this.mode) {
        case 'live':
          //url = url + '/' + encodeURI(this.resource);
          //url = 'http://159.149.15.66:1935/live2/_definst_/smil:' + this.resource + '.smil';
          if (!this.isazure) {
            url = url + '/_definst_/smil:' + this.resource + '.smil';
          }
          //supertemp
          url = "https://60757d6a7d81f.streamlock.net:1936/lecturec/fdpaulamagna"
          //url = 'http://159.149.15.66:1935/live2/_definst_/' + this.resource + ''
          //url = 'http://159.149.15.66:1935/lecturec/_definst_/livestream2'

          break;
        case 'vod':
        default: 
          if (mode == 'SMIL') {
            //var resource = this.resource.split("/")[this.resource.split("/").length - 1].replace('.mp4', '.smil');
            // PAZZESCO: bisogna encodare lo / in %5d!!!!
            // due giorni di lavoro!
            url = url + '/smil:smils%5c' + encodeURI(this.resource);
            break;
          }
          url = url + '/' + encodeURI(this.resource);
          break;
      }
      switch (streamtype) {
        case 'DASH':
          if (!this.isazure) {
            url = url + '/manifest.mpd';
          }
          break;
        case 'HSL':
          url = url + '/playlist.m3u8';
          break;
      }

      // DEBUG
      //url = 'http://159.149.15.66:1935/vod/_definst_/smil:s%5c7942.smil/manifest.mpd';

      console.log(url);
      return url;
    }
}

class PlayerShaka {
  constructor(desc) {
    this.desc = desc;
    this.logplay = true;

    var that = this;
    var playerContainer = this.desc.element
    var $video = $('video', this.desc.$element);
    var video = $video[0];

    var $gradient = $('<div class="gradient fade-object"></div>').appendTo(playerContainer);

    if (this.desc.istrack && this.desc.chapters) {
      this.cuechange = (track) => {
        var i = 0;
        if (track.activeCues[0]) {
          for (i = 0; i < track.cues.length; i++) {
            if (track.cues[i] == track.activeCues[0]) { break; }
          }
          $(this.desc.chapters).find('tr').removeClass('table-info').eq(i + this.desc.startchapter).addClass('table-info');
          if (this.desc.navigator) {
            var max = $(this.desc.navigator).data('count');
            $("li", $(this.desc.navigator)).addClass('d-none');
            $("li", $(this.desc.navigator)).removeClass('active');
            $(".page-num", $(this.desc.navigator)).each((index, e) => {
              if (index == 0 || index == max - 1) { $(e).removeClass('d-none'); }
              if (index >= i + desc.startchapter - 1 && index <= i + desc.startchapter + 1) { $(e).removeClass('d-none'); }
              if (index == i + desc.startchapter) { $(e).addClass('active'); }
            });
            if (i + desc.startchapter > 0) { $("li.page-prev", $(this.desc.navigator)).removeClass('d-none'); }
            if (i + desc.startchapter < max - 1) { $("li.page-next", $(this.desc.navigator)).removeClass('d-none'); }
            if (i + desc.startchapter > 2) { $("li.page-lefthole", $(this.desc.navigator)).removeClass('d-none'); }
            if (i + desc.startchapter < max - 3) { $("li.page-righthole", $(this.desc.navigator)).removeClass('d-none'); }
          }
        }
      };
    }

    var $mediaplay = $('<div class="mediaplay">' + icons['play'] + '</div>')
      .on('click', 'svg', (e) => {
        e.preventDefault();
        if (video.readyState === 4) {
          if (video.paused) {
            video.play();
            this.setPlayMode($(e.target), 'pause');
          }
          else {
            video.pause();
            this.setPlayMode($(e.target), 'play');
          }
        }
      })
      .appendTo(playerContainer);

    if (this.desc.iscustomcontrols) {
      var $commands = $('<div class="commands fade-object"><div class="playBox"><button class="playButton"></button></div><div class="timelineBox"></div><div class="audioBox"><button class="audioButton"></button></div><div class="volumeBox"><div class="volume" /></div><div class="fullscreenBox"><button class="fullscreenButton">fullscreen</button></div></div>');
      if (this.desc.mode == 'vod') {
        var linkBack = this.desc.isembed ? '<div><a style="color: #fff" href="https://video.unimi.it" target="_blank">LA STATALE <strong>VIDEO</strong></a></div>' : '';
        $commands = $('<div class="commands fade-object"><div class="playBox"><button class="playButton"></button></div><div class="timelineBox"><div class="timeline" /></div><div class="durationBox" /><div class="audioBox"><button class="audioButton"></button></div><div class="volumeBox"><div class="volume" /></div><div class="fullscreenBox"><button class="fullscreenButton">fullscreen</button></div>' + linkBack + '</div>');
      }
      $commands.appendTo(playerContainer);

      var $playButton = $('.playButton', $commands)
        .click((e) => {
          e.preventDefault();
          if (video.readyState === 4) {
            if (video.paused) {
              video.play();
              this.setPlayMode($playButton, 'pause');
            }
            else {
              video.pause();
              this.setPlayMode($playButton, 'play');
            }
          }
        });
      var $audioButton = $('.audioButton', $commands)
        .html(icons['audio-on'])
        .click((e) => {
          e.preventDefault();
          video.muted = !video.muted;
          $audioButton.html(icons[video.muted ? 'audio-off' : 'audio-on']);
        });
      // TODO IL fullscreen ha problemi se il video è 4/3
      var $fullscreenButton = $('.fullscreenButton', $commands)
        .html(icons['fullscreen'])
        .click((e) => {
          e.preventDefault();
          if (document.fullscreenElement) {
            document.exitFullscreen();
            $fullscreenButton.html(icons['fullscreen']);
          } else {
            playerContainer.requestFullscreen();
            $fullscreenButton.html(icons['restore']);
          }
        });
      var $timeline = $('.timeline', $commands)
        .append('<div class="bar" /><div class="progress" />')
        .on('mousedown', (e) => {
          e.preventDefault();
            var x = e.pageX - $(e.currentTarget).offset().left
            var value = Math.floor(x * video.duration / e.target.offsetWidth);
            video.currentTime = value;
        })
        .on('mousemove', (e) => {
          e.preventDefault();
          if (e.buttons) {
              var x = e.pageX - $(e.currentTarget).offset().left
              var value = Math.floor(x * video.duration / e.target.offsetWidth);
              video.currentTime = value;
          }
        });
      var $volume = $('.volume', $commands)
        .append('<div class="bar" /><div class="progress" />')
        .on('mousedown', (e) => {
          e.preventDefault();
          video.volume = e.offsetX / e.target.offsetWidth;
        })
        .on('mousemove', (e) => {
          e.preventDefault();
          if (e.buttons) {
              video.volume = e.offsetX / e.target.offsetWidth;
          }
        });
    }
    else {
      $video.attr('controls', 'controls')
    }

    if (this.desc.isinfooverlay && (this.desc.istrack || this.desc.title)) {
      if (this.desc.title) {
        var $mediatitle = $('<div class="mediainfo top fade-object"><h2 class="display-3">' + this.desc.title + '</h3></div>').appendTo(playerContainer);
      }
      if (this.desc.istrack) {
        var $mediainfo = $('<div class="mediainfo bottom fade-object"><h3></h3><p class="lead"></p></div>');
      }
    }

    function setDefaultBandWidth(player){
        var config = {abr: {
            enabled: true,
          defaultBandwidthEstimate: 8e5
        }};
        // var abr = new shaka.abr.SimpleAbrManager();
        // abr.setDefaultEstimate(8e5);
        // config.abr.manager = abr;
        // config.abr.defaultBandwidthEstimate = 8e5;
        player.configure(config);
    }

    var player = new shaka.Player(video);

    video.addEventListener('canplay', (event) => {
      if (this.desc.autoplay) {
        //this.log();
        video.muted = true;
        $audioButton.html(icons[video.muted ? 'audio-off' : 'audio-on']);
        video.play();
      }
    });

    player.addEventListener('error', PlayerUtils.onErrorEvent);

    player.addEventListener('adaptation', (e) => {
      var tracks = player.getVariantTracks();  // all tracks
      tracks.forEach(function(t) {
        if (t.active) {  // an active track, that is, in use by the player right now
          console.log('ACTIVE:', t.type, t);
        }
      });
    });

    video.addEventListener('loadeddata', (e) => {
      var state = {
        player: this.desc.playerId,
        time: $video.data('startat') ? $video.data('startat') : 0
      }
      history.replaceState(state, '', '');

      if (this.desc.startat) {

        video.currentTime = this.desc.startat;
      }

      this.updatetime(video, $commands, $timeline)
      // if (this.desc.iscustomcontrols) {
      //   var currentTimeLength = video.duration.toHHMMSS().length;
      //   $('.durationBox', $commands).text('' + video.currentTime.toHHMMSS(currentTimeLength) + ' / ' + video.duration.toHHMMSS());
      //   $('.progress', $timeline).css('width', '' + Math.floor(video.currentTime * 100 / video.duration) + '%');
      // }

    });

    $video
      .bind('timeupdate', (e) => {
        this.updatetime(video, $commands, $timeline)
        if(this.desc.mode !== 'live' && video.currentTime >= this.desc.endat) {
          // per sbloccare il play, rimuoviamo la condizione di termine
          this.desc.endat = 1000000;
          video.pause();
        }
        // if (this.desc.iscustomcontrols) {
        //   var currentTimeLength = video.duration.toHHMMSS().length;
        //   $('.durationBox', $commands).text('' + video.currentTime.toHHMMSS(currentTimeLength) + ' / ' + video.duration.toHHMMSS());
        //   $('.progress', $timeline).css('width', '' + Math.floor(video.currentTime * 100 / video.duration) + '%');
        // }
      })
      .bind('volumechange', (e) => {
        if (this.desc.iscustomcontrols) {
          $('.progress', $volume).css('width', '' + (video.volume * 100) + '%');
        }
      })
      .bind('play', (e) => {
        this.log('play');
        $mediaplay.hide();
        if (this.desc.iscustomcontrols) {
          this.setPlayMode($playButton, 'pause');
        }
      })
      .bind('pause', (e) => {
        $mediaplay.show();
        if (this.desc.iscustomcontrols) {
          this.setPlayMode($playButton, 'play');
        }
      });


    player.load(this.desc.getManifestURL('DASH')).then(() => {
      // This runs if the asynchronous load is successful.
      setDefaultBandWidth(player);
      this.setPlayMode($playButton, 'play');
      $video.trigger('volumechange');

      if (this.desc.istrack) {
        console.log(this.desc.tracksrc);
        player.addTextTrack(this.desc.tracksrc, 'it', 'chapters', 'text/vtt').then((e) => {
          player.selectTextTrack(0);
          var chapterlistBuilt = false;
          var track = video.textTracks[0];

          track.oncuechange = (e) => {
            console.log('cue changed');
            // viene inserito il box del capitolo se c'è più di un Capitolo
            if (track.cues.length && track.cues.length > 0) {
              if (!$.contains(playerContainer, $mediainfo[0])) {
                $mediainfo.appendTo(playerContainer)
              }
            } // if

            if (track.activeCues[0]) {
              for (var i = 0; i < track.cues.length; i++) {
                if (track.cues[i] == track.activeCues[0]) {
                  break;
                }
              } // for

              // se ci fosse solo un capitolo, queste due info verrebbero aggiunte senza essere visualizzate
              // ma va bene
              if (this.desc.isinfooverlay) {
                $('h3', $mediainfo).text('Capitolo ' + (i + this.desc.startchapter + 1));
                $('p', $mediainfo).text(track.activeCues[0].text);
              }

              if (this.cuechange) {
                console.log('found cuechange handler');
                this.cuechange(track);
              }

              //console.log(track.activeCues[0].text);
            } // if
            console.log(player);
          }; // oncuechange handler
        });
      } // if

    }).catch(PlayerUtils.onError);  // onError is executed if the asynchronous load fails.
  }

  log() {
    if (this.logplay) {
      this.logplay = false;
      $.get(`/log?mid=${this.desc.mid}&cid=${this.desc.cid|0}&mode=${this.desc.isembed ? 'embed' : 'origin'}&type=shaka`);
      //gtag('event', 'videoplay', { 'event_category': 'mid', 'event_label': this.desc.mid });
      //gtag('event', 'videoplay', { 'event_category': 'cid', 'event_label': this.desc.cid });
      //gtag('event', 'videoplay', { 'event_category': 'mode', 'event_label': 'shaka' });
    }
  }

  seek(time) {
    $('video', this.desc.$element)[0].currentTime = time;
  }

  updatetime(video, $commands, $timeline) {
    if (this.desc.iscustomcontrols) {
      var currentTimeLength = video.duration.toHHMMSS().length;
      $('.durationBox', $commands).text('' + video.currentTime.toHHMMSS(currentTimeLength) + ' / ' + video.duration.toHHMMSS());
      $('.progress', $timeline).css('width', '' + Math.floor(video.currentTime * 100 / video.duration) + '%');
    }
  }

  setPlayMode(button, mode) {
    if (this.desc.iscustomcontrols) {
      button.attr('aria-label', mode);
      button.attr('title', mode);
      button.html(icons[mode]);
    }
  }

  playVideo(video) {
    if (video.readyState === 4) {
      if (video.paused) {
        video.play();
        //this.setPlayMode($(this), 'pause');
      }
      else {
        video.pause();
        //this.setPlayMode($(this), 'play');
      }
    }
  }

}

class PlayerFlash {
  constructor(desc) {
    this.desc = desc;

    var playerContainer = this.desc.element

    // elimino il tag video
     $('video', playerContainer).remove();
     var jw = $('<div id="jw-' + this.desc.playerId + '">').appendTo(playerContainer);

    // flash
     this.jwplayer = jwplayer(jw[0]).setup({
        image: this.desc.poster,
        title: this.desc.title,
        aspectratio: '16:9',
        width: '100%',
        primary: 'html5',
        sources: [{	file: this.desc.getManifestURL('RTMP')	}],
        fallback: false,
      });

    var firstPlay = true;
    this.jwplayer.on('play', (e) => {
      if(firstPlay && this.desc.startat) {
        this.seek(this.desc.startat);
      }
      firstPlay = false;
    });
  }

  seek(time) {
    this.jwplayer.seek(time);
  }
}

class PlayerNative {
  constructor(desc) {
    // This browser does not have the minimum set of APIs we need.
    this.desc = desc;
    this.logplay = true;

    if (this.desc.istrack && this.desc.chapters) {
      this.cuechange = (track) => {
        var i = 0;
        if (track.activeCues[0]) {
          for (i = 0; i < track.cues.length; i++) {
            if (track.cues[i] == track.activeCues[0]) { break; }
          }
          $(this.desc.chapters).find('tr').removeClass('table-info').eq(i + this.desc.startchapter).addClass('table-info');
          if (this.desc.navigator) {
            var max = $(this.desc.navigator).data('count');
            $("li", $(this.desc.navigator)).addClass('d-none');
            $("li", $(this.desc.navigator)).removeClass('active');
            $(".page-num", $(this.desc.navigator)).each((index, e) => {
              if (index == 0 || index == max - 1) { $(e).removeClass('d-none'); }
              if (index >= i + desc.startchapter - 1 && index <= i + desc.startchapter + 1) { $(e).removeClass('d-none'); }
              if (index == i + desc.startchapter) { $(e).addClass('active'); }
            });
            if (i + desc.startchapter > 0) { $("li.page-prev", $(this.desc.navigator)).removeClass('d-none'); }
            if (i + desc.startchapter < max - 1) { $("li.page-next", $(this.desc.navigator)).removeClass('d-none'); }
            if (i + desc.startchapter > 2) { $("li.page-lefthole", $(this.desc.navigator)).removeClass('d-none'); }
            if (i + desc.startchapter < max - 3) { $("li.page-righthole", $(this.desc.navigator)).removeClass('d-none'); }
          }
        }
      };
    }


    var playerContainer = this.desc.element
    var $video = $('video', playerContainer);
    $video[0].src = this.desc.getManifestURL('HSL');
    $video[0].setAttribute('controls','controls')

    $video.on('loadedmetadata', () => {
      if (this.desc.istrack) {
        $.getJSON(this.desc.tracksrc + '&json', (data) => {
          var track = $video[0].addTextTrack("chapters", "Ita", "it");
          track.oncuechange = (e) => {
            this.cuechange(track);
          };
          $.each(data.chapters, function() {
            track.addCue(new VTTCue(this.startat, this.endat, "[Test]"));
          })
        });
      }
    });

    $video.bind('play', () => {
      this.log();
    });
  }



  log() {
    if (this.logplay) {
      this.logplay = false;
      $.get(`/log?mid=${this.desc.mid}&cid=${this.desc.cid|0}&mode=${this.desc.isembed ? 'embed' : 'origin'}&type=native`);
      gtag('event', 'videoplay', { 'event_category': 'mid', 'event_label': this.desc.mid });
      gtag('event', 'videoplay', { 'event_category': 'cid', 'event_label': this.desc.cid });
      gtag('event', 'videoplay', { 'event_category': 'mode', 'event_label': 'native' });
    }
  }

  seek(time) {
    $('video', this.desc.$element)[0].currentTime = time;
  }
}

function initApp() {
    // Install built-in polyfills to patch browser incompatibilities.
    shaka.polyfill.installAll();
    jwplayer.key="3sJcql5DN4/5JHCLKHPN0VBppqOgiEGma50yAg==";

    var playerMode = PlayerUtils.GetPlayerMode();
    //playerMode = 'FLASH';
    var players = [];

    // cicla in tutti i container player trovati nella pagina
    $(".mediaContainer").each(function(e) {

      var desc = new PlayerDesc(this);

      switch (playerMode) {
        case 'SHAKA':
          players[desc.playerId] = new PlayerShaka(desc);
          break;
        case 'FLASH':
          players[desc.playerId] = new PlayerFlash(desc);
          break;
        case 'NATIVE':
          players[desc.playerId] = new PlayerNative(desc);
          break;
      }

      // init chapter $links
      if (desc.chapters) {
        $(desc.chapters)
          .on('click', '.clickable-row.samefile', (e) => {
            var player = players[desc.playerId];
            var time = $(e.currentTarget).data('startat');
            var playerid = $(e.currentTarget).data('playerid');
            var mid = $(e.currentTarget).data('mid');
            var cid = $(e.currentTarget).data('cid');
            if (player && player.seek) {
              player.seek(time);

              if (desc.ishistory) {
                 var state = {
                   player: playerid,
                   time: time
                 }
                 history.pushState(state, '', '/media/' + mid + '/' + cid + '/');
              }
            }
          })
          .on('click', '.clickable-row.file', (e) => {
            window.location = '/media/' + $(e.currentTarget).data("mid") + '/' + $(e.currentTarget).data("cid");
          });
      }

      if (desc.navigator) {
        $(desc.navigator)
          .on('click', 'li.samefile a', (e) => {
            var time, mid, cid;
            e.preventDefault();
            var player = players[desc.playerId];
            var $li = $(e.currentTarget.parentElement);
            var $dataElement = null;
            if ($li.hasClass('page-num')) {
              $dataElement = $(e.currentTarget);
            }
            else {
              if ($li.hasClass('page-prev')) {
                $dataElement = $(desc.navigator).find('li.active').prevAll('.page-num').eq(0).find('a');
              }
              else if ($li.hasClass('page-next')) {
                $dataElement = $(desc.navigator).find('li.active').nextAll('.page-num').eq(0).find('a');
              }
            }
            if ($dataElement && player && player.seek) {
              console.log($dataElement);
              time = $dataElement.data('startat');
              mid = $dataElement.data('mid');
              cid = $dataElement.data('cid');

              player.seek(time);

              if (desc.ishistory) {
                 var state = {
                   player: desc.playerId,
                   time: time
                 }
                 history.pushState(state, '', '/media/' + mid + '/' + cid + '/');
              }
            }
          })
          .on('click', 'li.file a', (e) => {
            e.preventDefault();
            var $dataElement = null;
            var $li = $(e.currentTarget.parentElement);
            if ($li.hasClass('page-num')) {
              $dataElement = $(e.currentTarget);
            }
            else {
              if ($li.hasClass('page-prev')) {
                $dataElement = $(desc.navigator).find('li.active').prevAll('.page-num').eq(0).find('a');
              }
              else if ($li.hasClass('page-next')) {
                $dataElement = $(desc.navigator).find('li.active').nextAll('.page-num').eq(0).find('a');
              }
            }
            window.location = '/media/' + $dataElement.data("mid") + '/' + $dataElement.data("cid");
          });
      }
    });

    window.addEventListener('popstate', (e) => {
      $('#' + e.state.player + ' video')[0].currentTime = e.state.time;
    });

    var timer;
    var fadeInBuffer = false;
    $(document).mousemove(function () {
        if (!fadeInBuffer) {
            if (timer) {
                clearTimeout(timer);
                timer = 0;
            }

            $('.fade-object').fadeIn();
            $('html').css({
                cursor: ''
            });
        } else {
            fadeInBuffer = false;
        }

        timer = setTimeout(function () {
            $('.fade-object').fadeOut(2000);
            $('html').css({
                cursor: 'none'
            });
            fadeInBuffer = true;
        }, 2000)
    });

    var postid = $('#main').data('postid');
    var currentStatus = $('#main').data('status');

    if (postid) {
      setInterval(function() {
        $.get('/live-check/?postId=' + postid)
          .done(function(data) {
            if (data !== currentStatus) {
              location.reload();
            }
          });
      }, 30000);
    }

}

document.addEventListener('DOMContentLoaded', initApp);
